import * as React from "react";
import { useSearch, useLocation } from "wouter";
import { apiFetch } from "@/lib/api.js";

export default function ResetPasswordPage() {
  const search = useSearch();
  const [, navigate] = useLocation();
  const [password, setPassword] = React.useState("");
  const [confirm, setConfirm] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState("");
  const [success, setSuccess] = React.useState(false);

  const token = new URLSearchParams(search).get("token");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (password !== confirm) { setError("Passwords do not match"); return; }
    setError("");
    setLoading(true);
    try {
      await apiFetch("/api/auth/reset-password", { method: "POST", body: JSON.stringify({ token, password }) });
      setSuccess(true);
    } catch (err: any) {
      setError(err.message);
    }
    setLoading(false);
  };

  if (!token) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-paper p-4">
        <div className="w-full max-w-sm bg-card rounded-lg border border-clay-border p-8 text-center">
          <p className="text-sm text-error-text bg-error-wash rounded-md px-3 py-2 mb-4">Invalid reset link</p>
          <button onClick={() => navigate("/")} className="px-6 py-2.5 rounded-md bg-primary text-white text-sm font-medium hover:bg-amethyst-ink transition-colors">Back to Sign In</button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-paper p-4">
      <div className="w-full max-w-sm bg-card rounded-lg border border-clay-border p-8">
        <h1 className="text-2xl font-semibold text-amethyst-ink mb-1 font-headline tracking-[-0.01em]">New Password</h1>
        <p className="text-sm text-faint mb-6">Enter your new password</p>
        {success ? (
          <>
            <p className="text-sm text-success-text bg-success-wash rounded-md px-3 py-2 mb-4">Password reset successfully!</p>
            <button onClick={() => navigate("/")} className="w-full py-2.5 rounded-md bg-primary text-white text-sm font-medium hover:bg-amethyst-ink transition-colors">Sign In</button>
          </>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4">
            <input type="password" placeholder="New password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={8} className="w-full px-3 py-2.5 rounded-sm border border-clay-border text-sm text-body placeholder:text-faint focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary" />
            <input type="password" placeholder="Confirm password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required minLength={8} className="w-full px-3 py-2.5 rounded-sm border border-clay-border text-sm text-body placeholder:text-faint focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary" />
            <p className="text-[0.8125rem] text-faint -mt-2">Min 8 characters, one uppercase letter, one number</p>
            {error && <p className="text-[0.8125rem] text-error-text">{error}</p>}
            <button type="submit" disabled={loading} className="w-full py-2.5 rounded-md bg-primary text-white text-sm font-medium hover:bg-amethyst-ink transition-colors disabled:bg-clay-muted disabled:text-body disabled:cursor-not-allowed">
              {loading ? "..." : "Reset Password"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
